const accessTariffKey = 'access_tariff'
const viewPresentationKey = 'view_presentation'
const eventJournalKey = 'event_journal'

const DASHBOARD_TABS = {
  show: true,
  data: {
    information: {
      view: true,
      [accessTariffKey]: true,
      [viewPresentationKey]: false,
    },
    measurements: {
      view: true,
      [accessTariffKey]: true,
      [viewPresentationKey]: false,
    },
    files: {
      view: true,
      [accessTariffKey]: true,
      [viewPresentationKey]: false,
    },
    [eventJournalKey]: {
      view: true,
      [accessTariffKey]: true,
      [viewPresentationKey]: false,
    },
  },
}

const patchedDashboardUrls = new Set<string>()

export const registerHardcodedDashboardResponsePatch = (projectId: number) => {
  const dashboardPath = `/project/${projectId}/dashboard`

  if (patchedDashboardUrls.has(dashboardPath)) {
    return
  }

  const nativeFetch = window.fetch.bind(window)

  window.fetch = async (input, init) => {
    const response = await nativeFetch(input, init)
    const requestUrl = typeof input === 'string' ? input : input.url
    const requestPath = new URL(requestUrl, window.location.origin).pathname

    if (requestPath !== dashboardPath) {
      return response
    }

    const responseData = await response.clone().json()

    if (responseData?.data?.tabs?.show && Object.keys(responseData.data.tabs.data ?? {}).length > 0) {
      return response
    }

    return new Response(
      JSON.stringify({
        ...responseData,
        data: {
          ...responseData.data,
          tabs: DASHBOARD_TABS,
        },
      }),
      {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
      },
    )
  }

  patchedDashboardUrls.add(dashboardPath)
}
